import React, { useState } from 'react';
import { SectionWrapper, Card, Badge } from '../common';
import { services } from '../../data/services';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '24px',
  },
  icon: {
    fontSize: '36px',
    marginBottom: '16px',
    display: 'block',
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
    marginBottom: '4px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#94a3b8',
    marginBottom: '16px',
  },
  price: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#3b82f6',
    marginBottom: '24px',
  },
  featureList: {
    listStyle: 'none',
    marginBottom: '24px',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: '#cbd5e1',
    marginBottom: '12px',
  },
  checkIcon: {
    color: '#34d399',
    fontWeight: '700',
  },
  highlight: {
    fontSize: '13px',
    color: '#94a3b8',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    padding: '8px 12px',
    borderRadius: '6px',
    display: 'inline-block',
  },
};

export const Services = ({ isVisible }) => {
  const [activeService, setActiveService] = useState(0);

  return (
    <SectionWrapper
      id="diensten"
      label="Onze diensten"
      title="Wat wij doen"
      subtitle="Geen tools. Geen consultants. Gewoon: werkende data."
      isVisible={isVisible}
    >
      <div style={styles.grid}>
        {services.map((service, i) => (
          <Card
            key={i}
            highlighted={service.popular}
            scaled={activeService === i}
            onMouseEnter={() => setActiveService(i)}
          >
            {service.popular && (
              <Badge variant="popular">Meest gekozen</Badge>
            )}
            <span style={styles.icon}>{service.icon}</span>
            <h3 style={styles.title}>{service.title}</h3>
            <p style={styles.subtitle}>{service.subtitle}</p>
            <div style={styles.price}>{service.price}</div>
            <ul style={styles.featureList}>
              {service.features.map((feature, j) => (
                <li key={j} style={styles.featureItem}>
                  <span style={styles.checkIcon}>✓</span>
                  {feature}
                </li>
              ))}
            </ul>
            <div style={styles.highlight}>{service.highlight}</div>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
};
